import createIcon from '../../createIcon';

/**
 * @component @name Highlight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4wMDQ4OCAxNEw5LjAwNDg4IDE3VjIySDE1LjAwNDlWMTdMMTguMDA0OSAxNFY5SDYuMDA0ODhWMTRaTTExLjAwNDkgMkgxMy4wMDQ5VjVIMTEuMDA0OVYyWk0zLjUwNDg4IDUuODhMNC45MTQ4OCA0LjQ3TDcuMDM0ODggNi41OUw1LjYyNDg4IDhMMy41MDQ4OCA1Ljg4Wk0xNi45NjQ5IDYuNTlMMTkuMDg0OSA0LjQ3TDIwLjQ5NDkgNS44OEwxOC4zODQ5IDhMMTYuOTY0OSA2LjU5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Highlight = createIcon('Highlight', [
  [
    'path',
    {
      d: 'M6.00488 14L9.00488 17V22H15.0049V17L18.0049 14V9H6.00488V14ZM11.0049 2H13.0049V5H11.0049V2ZM3.50488 5.88L4.91488 4.47L7.03488 6.59L5.62488 8L3.50488 5.88ZM16.9649 6.59L19.0849 4.47L20.4949 5.88L18.3849 8L16.9649 6.59Z',
      key: '1ffskr',
    },
  ],
]);

export default Highlight;
